<template>
  <div class="living-page">
    <main class="page-container">
      <div class="back-arrow" @click="goBack">
        <i class="el-icon-arrow-left"></i>
      </div>
      <img src="@/assets/live/page-bg.webp" class="page-bg" />
      <div class="page-title-box">
        <!-- <p :text="liveTheme" class="live-text">{{ liveTheme }}</p> -->
        <p :text="liveArea" class="live-text live-title">{{ liveArea }}</p>
        <p :text="liveTitle" class="live-text live-title">{{ liveTitle }}</p>
      </div>
      <div class="video-container">
        <div v-if="isStart && !isEnd" class="video-box">
          <VideoM3U8 :video-url="livingUrl" />
        </div>
        <div v-if="!isStart && !isEnd" class="tip-container">
          <p class="t1">直播暂未开始</p>
          <p class="t2">敬请期待</p>
        </div>
        <div v-if="isEnd" class="tip-container">
          <p class="t1">直播已结束</p>
          <p class="t2">感谢您的观看</p>
        </div>
      </div>
      <img class="foot-img" src="@/assets/live/foot.png" />

      <div v-if="!isEnd">
        <div class="page-container-countdown">
          <div
            v-if="
              days != 0 || hours != '00' || minutes != '00' || seconds != '00'
            "
            class="countdown-container"
          >
            <div class="countdown-box">
              <p class="countdown-title">距离直播开始还有</p>
              <div v-if="days > 0" class="countdown-day">
                <p class="countdown-number">{{ days }}</p>
                <p class="countdown-title">天</p>
              </div>
              <div v-else class="countdown-num">
                <p class="countdown-number">{{ hours }}</p>
                <p class="colon">:</p>
                <p class="countdown-number">{{ minutes }}</p>
                <p class="colon">:</p>
                <p class="countdown-number">{{ seconds }}</p>
              </div>
            </div>
            <p class="countdown-title">({{ livingStartDay }})</p>
          </div>
          <div v-else class="living-text">正在直播</div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import VideoM3U8 from "@/components/VideoM3U8";
import { formatDate } from "@/utils/common.js";

export default {
  name: "LivingPage",
  components: { VideoM3U8 },
  data() {
    return {
      /* living */
      liveTheme: "",
      liveArea: "",
      liveTitle: "",
      livingUrl: "", // 直播地址
      startTime: "", // 直播开始时间戳
      endTime: "", // 直播结束时间戳
      livingStartDay: "",
      /* countdown */
      days: "1",
      hours: "",
      minutes: "",
      seconds: "",
      isStart: false,
      isEnd: true,
      countdownTimer: null,
      endTimer: null,
    };
  },
  watch: {
    seconds(newVal) {
      this.isStart =
        this.days == 0 &&
        Number(this.hours) == 0 &&
        Number(this.minutes) == 0 &&
        Number(newVal) == 0;
    },
  },
  created() {
    this.getLivingDate();
  },
  beforeDestroy() {
    this.clearTimers();
  },
  methods: {
    // 获取直播数据
    getLivingDate() {
      this.axios
        .get("/api/Index/PlayTime")
        .then((response) => {
          const res = response.data;
          const hasData = res?.code === 0 && Object.keys(res?.msg || {}).length;
          const { LiveUrl, StartTime, EndTime, LiveMemo } = res.msg;
          const [liveArea, liveTitle] = (LiveMemo || "").split(",");
          this.liveTheme = res.msg.LiveName || "";
          this.liveArea = liveArea;
          this.liveTitle = liveTitle;
          this.livingUrl = LiveUrl || "";
          this.startTime = new Date(formatDate(StartTime)).getTime() / 1000 + " ";
          this.endTime = new Date(formatDate(EndTime)).getTime() / 1000 + " ";
          this.livingStartDay = formatDate(StartTime, "yyyy-MM-dd");
          this.countdown(this.startTime);
          this.monitorLivingEnd(this.endTime);
        })
        .catch((err) => {
          console.error("[Living] PlayTime 接口异常:", err);
        });
    },
    clearTimers() {
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      if (this.endTimer) clearInterval(this.endTimer);
    },
    countdown(timestamp) {
      const self = this;
      this.clearTimers();
      this.countdownTimer = setInterval(function () {
        const nowTime = new Date();
        const endTime = new Date(timestamp * 1000);
        const t = endTime.getTime() - nowTime.getTime();
        if (t > 0) {
          const day = Math.floor(t / 86400000);
          let hour = Math.floor((t / 3600000) % 24);
          let min = Math.floor((t / 60000) % 60);
          let sec = Math.floor((t / 1000) % 60);
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;

          self.days = day;
          self.hours = hour;
          self.minutes = min;
          self.seconds = sec;
        } else {
          clearInterval(self.countdownTimer);
          self.days = "0";
          self.hours = "00";
          self.minutes = "00";
          self.seconds = "00";
        }
      }, 1000);
    },
    monitorLivingEnd(timestamp) {
      const self = this;
      this.endTimer = setInterval(function () {
        const nowTime = new Date();
        const endTime = new Date(timestamp * 1000);
        const t = endTime.getTime() - nowTime.getTime();
        if (t > 0) {
          self.isEnd = false;
        } else {
          clearInterval(self.endTimer);
          self.isEnd = true;
        }
      }, 1000);
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.living-page {
  p {
    margin: 0;
    padding: 0;
  }
}
.page-container {
  max-width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.back-arrow {
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 10;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
}
.page-bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -2;
  width: 100%;
  height: 100%;
}
.page-title-box {
  text-align: center;
  width: 100%;
  min-height: 226px;
  height: auto;
  background: url("~@/assets/live/live-title-bg.webp") no-repeat top center;
  background-size: 100% auto;
  padding: 104px 20px 30px;
  box-sizing: border-box;
}
.live-text {
  position: relative;
  font-size: 28px;
  font-weight: bold;
  font-style: italic;
  padding-right: 10px;
  background-image: linear-gradient(
    268deg,
    #fff08a 1%,
    #fffedf 36%,
    #fff08a 63%,
    #fffedf 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.live-title {
  font-size: 28px;
}
.live-text::before {
  content: attr(text);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  text-align: center;
  z-index: -1;
  color: transparent;
  text-shadow: 4px 4px 4px rgba(108, 7, 0, 0.75);
}

.video-container {
  width: 333px;
  height: 190px;
  margin-top: 30px;
}
.tip-container {
  width: 100%;
  height: 100%;
  background-image: linear-gradient(#000, #353333, #353333, #353333, #000);
  border-radius: 8px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.t1,
.t2 {
  padding: 0;
  margin: 0;
}
.t1 {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
}
.t2 {
  font-size: 16px;
  color: #fff;
  margin-top: 10px;
}
.video-box {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  border: 3px solid #ffeed4;
  box-sizing: border-box;
}

.foot-img {
  width: 115px;
  height: 14px;
}

.current-themeName {
  margin-top: 30px;
  height: 23px;
  padding: 0 8px;
  box-sizing: border-box;
  background-color: #e43104;
  border: 1px solid #fff5aa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 13px;
  font-weight: bold;
  color: #fef1a7;
}
.page-container-countdown {
  margin-top: 30px;
}
.countdown-container {
  display: flex;
  align-items: center;
  column-gap: 5px;
}
.living-text {
  width: 133px;
  height: 23px;
  background: #e43104;
  border: 1px solid #fff5aa;
  border-radius: 4px;
  display: grid;
  place-items: center;
  margin-top: 15px;

  font-size: 13px;
  font-weight: bold;
  color: #fef1a7;
}
.countdown-box {
  display: flex;
  align-items: center;
  column-gap: 5px;
}
.countdown-title {
  font-size: 14px;
  font-weight: bold;
  color: #fff;
}
.countdown-number {
  width: 25px;
  display: inline-block;
  box-sizing: border-box;
  height: 23px;
  background-color: #fff;
  border-radius: 3px;
  font-size: 16px;
  font-weight: bold;
  color: #ca2403;
  display: flex;
  justify-content: center;
  align-items: center;
}
.countdown-day {
  display: flex;
  align-items: center;
  column-gap: 4px;
}
.countdown-num {
  width: 115px;
  height: 31px;
  background-color: rgba(255, 255, 255, 0);
  border: 2px solid #fff;
  box-shadow: 0px 1px 20px 0px rgba(255, 255, 255, 0.6);
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.colon {
  height: 21px;
  font-size: 17px;
  font-weight: bold;
  color: #fff;
  padding: 0 3px;
}
</style>

<style lang="scss">
/* video.js 全局样式覆盖 */
.video-js {
  border-radius: 10px;
}
.video-js video {
  border-radius: 7px;
}
.video-js .vjs-big-play-button {
  width: 50px;
  height: 30px;
  font-size: 20px;
  text-align: center;
  top: 40%;
  left: 40%;
}
</style>
